<template>
    <div class="full-width content-box" :class="classname">
        <div class="span-box">
            <span class="content-span">{{obj.addinfo2}}</span>
        </div>
    </div>
</template>

<script setup>
    import {inject, ref, onMounted, onBeforeMount, computed, toRef} from "vue";

    const props = defineProps(["obj", "selectAddinfo1", "selectAddinfo2"])

    const classname = computed(() => {
        let name = 'unavailable-part'

        if (null != props.obj && props.obj.recordno == 0){
            name = 'available-part'
        }

        if (null != props.obj && props.obj.recordno == 1){
            name = 'unavailable-part-2'
        }

        if (null != props.selectAddinfo1 && null != props.selectAddinfo2 && null != props.obj && props.obj.addinfo1 == props.selectAddinfo1 && props.obj.addinfo2 == props.selectAddinfo2){
            name = 'selected-available-part'
        }

        return name

    })

</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .content-box {
        padding-top: 100%;
        position: relative;
        text-align: center;
        box-sizing: border-box;
    }

    .span-box {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
    }

    .content-span {
        /*line-height: 100%;*/
        font-weight: 600;
        font-size: 24px; transform: rotateX(180deg);
    }

    .available-part {
        background: #f4f4f5;
        color: #909399;
        cursor: pointer;
    }

    .available-part:hover{
        background: #dedfe0
    }

    .unavailable-part {
        background: #F56C6C;
        color: #ffffff;
        cursor: no-drop;
    }

    .unavailable-part-2 {
        background: #E6A23C;
        color: #ffffff;
        cursor: no-drop;
    }

    .selected-available-part {
        background: #67C23A;
        color: #ffffff;
    }
</style>